import { render, staticRenderFns } from "./Ligas.view.vue?vue&type=template&id=718153d8"
import script from "./Ligas.view.vue?vue&type=script&lang=js"
export * from "./Ligas.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports